import React from 'react'
import './CSS/line.css'

export default function Line(){

    return (

        <>
          <div class="line-container">
                <div class="line"></div>
             </div>
        </>
    )
}